"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EActiveTab = void 0;
let EActiveTab = exports.EActiveTab = /*#__PURE__*/function (EActiveTab) {
  EActiveTab["Authentication"] = "authentication";
  EActiveTab["Registration"] = "registration";
  return EActiveTab;
}({});